import React, { Component } from 'react';
import History_Dynamic_Data from './History_Dynamic_Data';
import { isEmpty, getLocale, df_options } from '../../Common/Common';

export default class History extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let card_style = {
			width: this.props.width - 40,
			margin: 'auto',
			borderRadius: 10,
			backgroundColor: 'white',
			padding: 5,
			marginBottom: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		let is_landscape = false;
		if (this.props.width > this.props.height) is_landscape = true;

		let td_date_style = {
			width: is_landscape ? (this.props.width - 40) / 6 : '50%', // 100% divide by 6 columns
			display: 'inline-block',
			textAlign: 'left',
			verticalAlign: 'top',
		}

		let td_type_style = {
			width: is_landscape ? (this.props.width - 40) / 6 : '50%', // 100% divide by 6 columns
			display: 'inline-block',
			verticalAlign: 'top',
		}

		let td_data_style = {
			width: is_landscape ? (this.props.width - 40) / 2 : '100%', // 100% divide by 6 columns
			display: is_landscape ? 'inline-block' : 'block',
			verticalAlign: 'top',
		}

		let td_operator_style = {
			width: is_landscape ? (this.props.width - 40) / 6 : '100%', // 100% divide by 6 columns
			display: is_landscape ? 'inline-block' : 'block',
			verticalAlign: 'top',
		}

		/*
		 * Filters index
		 * 0 = timestamp
		 * 1 = type
		 * 2 = command
		 * 3 = point id/function id
		 * 4 = data
		 * 5 = operator (i.e. who)
		 */

		let timstamp = this.props.history_row_item[0].toString();
		let year = parseInt(timstamp.substring(0, 4));
		let month = parseInt(timstamp.substring(4, 6)) - 1;
		let date = parseInt(timstamp.substring(6, 8));
		let hour = parseInt(timstamp.substring(8, 10));
		let min = parseInt(timstamp.substring(10, 12));

		let locale = getLocale(this.props.receiver.lang);
		let display_date = new Date(year, month, date, hour, min).toLocaleString(locale, df_options);

		let display_name = this.props.history_row_item[3];

		let point_info = window.app.state.point_list[this.props.history_row_item[3]];
		if (!isEmpty(point_info)) display_name = point_info.name;

		return (
			<div style={card_style}>
				<div style={td_date_style}>
					<span className='footnote'>{display_date}</span>
				</div>
				<div style={td_type_style}>
					<div style={{ display: 'inline-block' }}>
						<span className='footnote' style={{ color: 'black' }}>{this.props.receiver.getString(this.props.history_row_item[1])}</span>
					</div>
				</div>
				<div style={td_data_style}>
					<History_Dynamic_Data
						type={this.props.history_row_item[1]}
						command={this.props.history_row_item[2]}
						target_id={this.props.history_row_item[3]}
						data={this.props.history_row_item[4]}
						operator={this.props.history_row_item[5]}
						history_row_item={this.props.history_row_item}
						receiver={this.props.receiver}
					/>
				</div>
				<div style={td_operator_style}>
					<div style={{ display: this.props.history_row_item[1] == 'op' && this.props.history_row_item[5] != null && this.props.history_row_item[5] != '' ? 'block' : 'none', textAlign: 'right' }}>
						<div style={{ display: is_landscape ? 'none' : 'inline-block' }}>
							<span className='footnote'>{this.props.receiver.getString('sent_by') + ': '}</span>
						</div>
						<div style={{ display: 'inline-block', }}>
							<span className='footnote'>{this.props.history_row_item[5]}</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}